<template>
    <div>     
        <material-card color='green' v-for="(post,i) in BloggerPosts" :title="post.title" v-bind:key="post.id">
            <div v-html="post.content"> </div>
            <!-- Hardcoded datetime..-->
            <h5>Posted on {{post.published.split('T')[0]}}</h5>
        </material-card>
    </div>
</template>

<script>

   export default {
    data() {
        return {           
            TestBlogPost:"",
            BloggerPosts:[]
        };
    },
    async created() {
        var self = this;
        var res = await this.$http.get("blog/bad11/posts");
        //Top 5 posts only
        this.BloggerPosts = res.data.items.slice(0,5);


    }}
</script>

<style scoped>

</style>